<template>
<div class="bto-sb-widget-horse-events-nonrunnings">
  <div class="bto-sb-widget-title">
    <h4>{{t('HR.NonRunners')}}</h4>
  </div>
  <div class="bto-sb-widget-horse-events">
    <ul class="bto-sb-horse-events-items">
      <li class="bto-sb-horse-events-item" v-for="(item,idx) in items" :key="idx">
        <div class="bto-sb-horse-event">
          <div class="bto-sb-horse-event-content">
            <div class="bto-sb-horse-event-item">
              <div class="bto-sb-horse-event-item-content">
                <div class="bto-sb-horse-event-item-no" v-if="selectedSport === horseRacingSportId">
                  <span>{{item.runnerNumber}}</span>
                  <span>{{(item.age)}}</span>
                  <!-- <div class="bto-sb-horse-event-item-stat">
                    <a :title="$translate.text('Match.Statistics.Title')"></a>
                  </div> -->
                </div>
                <div class="bto-sb-horse-event-item-img">
                  <img :src="getImageUrl(selectedSport === horseRacingSportId, item)" @error="item.useDefaultImage = true">
                </div>
                <div class="bto-sb-horse-event-item-name">
                  <span class="bto-sb-horse-racername">{{item.name}}</span>
                  <span class="bto-sb-horse-jockey" v-if="selectedSport === horseRacingSportId"><i>{{t('HR.J')}}</i>{{item.jockey}}</span>
                  <span class="bto-sb-horse-trainer"><i>{{t('HR.T')}}</i>{{item.trainer}}</span>
                  <span class="bto-sb-horse-raced" v-if="raceType !== 'Flat'"><i>{{t('HR.F')}}</i>{{item.prevPlaces}}</span>
                  <span class="bto-sb-horse-raced" v-if="raceType === 'Flat'"><i>{{t('HR.F')}}</i>{{item.prevFlatPlaces}}</span>
                </div>
                <div class="bto-sb-horse-event-item-odd">
                <div class="bto-sb-horse-event-item-odd-stat" v-if="item.prevOdds.length > 0">
                  <span>{{getPrevOddOutcome(item.prevOdds[0]) | formatOddDisplay($root.oddFormat)}}</span>
                  <span>{{getPrevOddOutcome(item.prevOdds[1]) | formatOddDisplay($root.oddFormat)}}</span>
                  <span>{{getPrevOddOutcome(item.prevOdds[2]) | formatOddDisplay($root.oddFormat)}}</span>
                </div>
               <div v-else class="bto-sb-horse-event-item-odd-stat">
                <span>{{'--'}}</span>
                <span>{{'--'}}</span>
                <span>{{'--'}}</span>
              </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
      <li class="bto-sb-horse-events-item" v-if="items.length <= 1"></li>
      <li class="bto-sb-horse-events-item" v-if="items.length <= 2"></li>
    </ul>
  </div>
</div>
</template>

<script>
  import store from '../../../store';
  
  export default {
    name: 'NonRunnersHr',
    props: {
      items: {
        type: Array,
        required: false,
        default: () => [],
      },
      selectedSport: {
        type: Number,
        required: true,
      },
      raceType: {
        type: String,
      },
    },
    computed: {
      horseRacingSportId() {
        return store.state.SportsModule.hrSportId;
      },
    },
    methods: {
      getImageUrl(isHorseRacing, item) {
        if (isHorseRacing) {
          if (item.useDefaultImage) {
            return `${APP_SETTINGS.path.baseUrl}/images/horse/4.png`;
          }
          const url = `${APP_SETTINGS.path.horseImageUrl}${item.jockeyFileName}`;
          return url;
        }
        return `${APP_SETTINGS.path.baseUrl}/images/greyhounds/${item.runnerNumber}dog-au.svg`;
      },
      getPrevOddOutcome(prevOdd) {
        return (prevOdd && prevOdd.outcome) || 0;
      },
    },
  };
</script>
